import { Grid } from '@mui/material'
import { ReactNode } from 'react'
import {
  SectionHeader,
  SectionLink,
  SectionLinkProps
} from '../../../components'
import { useIsMobile } from '../../../contexts'
import { useTextOrTranslation } from '../../../hooks'
import { isArrayWithLength } from '../../../utils'
import { MainContentSectionText } from './main-content-section-text'
import {
  MainContentSectionLinkGroup,
  MainContentSectionLinkGroupProps
} from './main-content-section-link-group'
import {
  MainContentSectionTextGroup,
  MainContentSectionTextGroupProps
} from './main-content-section-text-group'

interface MainContentSectionProps {
  headerPrimary?: ReactNode
  headerPrimaryId?: string
  headerSecondary?: ReactNode
  id: string
  noSectionItemsMessageId?: string
  noSectionItemsMessageText?: string
  sectionLinkProps?: Omit<SectionLinkProps, 'id'>
  sectionLinkGroups?: MainContentSectionLinkGroupProps['sectionLinkGroups']
  sectionTextItems?: MainContentSectionTextGroupProps['textItems']
}

export const MainContentSection = ({
  headerPrimary,
  headerPrimaryId,
  headerSecondary,
  id,
  noSectionItemsMessageId,
  noSectionItemsMessageText,
  sectionLinkProps,
  sectionLinkGroups,
  sectionTextItems
}: MainContentSectionProps) => {
  const isMobile = useIsMobile()

  const hasSectionItems =
    isArrayWithLength(sectionLinkGroups) || isArrayWithLength(sectionTextItems)
  const noSectionItemsMessage = useTextOrTranslation(
    noSectionItemsMessageText,
    noSectionItemsMessageId
  )

  const sectionLink = sectionLinkProps && (
    <SectionLink id={`${id}-section-link`} {...sectionLinkProps} />
  )

  return (
    <Grid container sx={{ mb: 2 }} rowSpacing={{ xs: 2, sm: 2, md: 1 }}>
      <Grid item md={12} sm={12} xs={12}>
        <SectionHeader
          isMobile={isMobile}
          linkElement={sectionLink}
          primaryText={headerPrimary}
          primaryTextId={headerPrimaryId}
          secondaryText={headerSecondary}
        />
      </Grid>
      <Grid item id={`${id}-section-items`} md={true} sm={12} xs={12}>
        {sectionLinkGroups && (
          <MainContentSectionLinkGroup sectionLinkGroups={sectionLinkGroups} />
        )}
        {sectionTextItems && (
          <MainContentSectionTextGroup textItems={sectionTextItems} />
        )}
        {!hasSectionItems && (
          <MainContentSectionText>
            {noSectionItemsMessage}
          </MainContentSectionText>
        )}
      </Grid>
      {!isMobile && (
        <Grid item md="auto">
          {sectionLink}
        </Grid>
      )}
    </Grid>
  )
}
